import { ButtonPosition } from '@/common/manager/position/button-position';
export const config = {
    value: 'wait',
    position: [
        ButtonPosition.form,
        ButtonPosition.dialog,
        ButtonPosition.formDialog,
        ButtonPosition.tableBatchArea,
        ButtonPosition.tableToolArea,
        ButtonPosition.tableOperate,
        ButtonPosition.tabEvent,
        ButtonPosition.subCardAction,
        ButtonPosition.arrayTableOperate,
        ButtonPosition.blockButton,
    ],
    action: (arg) => {
        const { buttonConfig } = arg || {};
        const { options } = buttonConfig || {};
        const { seconds } = options || {};
        if (typeof seconds === 'number') {
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve(true);
                }, seconds);
            });
        }
    },
};
